<template>
  <div>
    <div class="table-container">
      <table class="table is-fullwidth is-striped">
        <thead>
          <tr>
            <th>Component</th>
            <th>Pro Camera</th>
            <th>Installed</th>
            <th>Removed</th>
            <th>Reason / note</th>
            <th>Created by</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!history.data.length">
            <td colspan="6">No installation history.</td>
          </tr>
          <tr v-for="row in history.data" :key="row.id">
            <td>
              {{ row.type
              }}<small class="is-block">{{
                row.identifier || row.label || `#${row.component_id}`
              }}</small>
            </td>
            <td>{{ row.camera_serial || row.pro_camera_inventory_id }}</td>
            <td>{{ date(row.installed_at) }}</td>
            <td>
              {{
                row.removed_at ? date(row.removed_at) : "Currently installed"
              }}
            </td>
            <td>
              {{ row.removal_reason || "-"
              }}<small class="is-block history-note">{{ row.note }}</small>
            </td>
            <td>{{ row.created_by || "-" }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="history.last > 1" class="buttons">
      <button
        class="button is-small"
        :disabled="page <= 1 || loading"
        @click="$emit('change-page', page - 1)"
      >
        Previous</button
      ><span>Page {{ page }} of {{ history.last }}</span
      ><button
        class="button is-small"
        :disabled="page >= history.last || loading"
        @click="$emit('change-page', page + 1)"
      >
        Next
      </button>
    </div>
  </div>
</template>
<script>
import { formatDate } from "@/utils/date_converter";
export default {
  name: "InstallationHistory",
  props: {
    history: { type: Object, default: () => ({ data: [], last: 1 }) },
    page: { type: Number, default: 1 },
    loading: { type: Boolean, default: false },
  },
  methods: {
    date(value) {
      return value
        ? formatDate(value, {
            showTime: true,
            showRelative: false,
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          })
        : "Unknown";
    },
  },
};
</script>
<style scoped>
.table { min-width: 760px; }
.history-note {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  max-width: 280px;
}
</style>
